// lib
import React from 'react'
import { List } from 'immutable'
import PropTypes from 'prop-types'

// components
import VideoPopup from '@aytm/lib/rfd-ui/components/basic/video-popup'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

// styles
import '@aytm/lib/rfd-ui/styles/advanced/tutorial-video.scss'
import classNames from 'classnames'

// <Component>
export default class TutorialVideo extends PureDataComponent {
  static propTypes = {
    videos: PropTypes.instanceOf(List).isRequired,
    videoId: PropTypes.string,
    className: PropTypes.string,
    videoStartTime: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.openPopup = this.openPopup.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.state = {
      popup: false
    }
  }

  openPopup(event) {
    this.setState({
      popup: true
    })
    try {
      event?.preventDefault?.()
      event?.stopPropagation?.()
      event?.stopImmediatePropagation?.()
    } catch {
      //
    }
  }

  closePopup() {
    this.setState({
      popup: false
    })
  }

  render() {
    const { popup } = this.state
    const { videos, videoStartTime, videoId, className } = this.props
    return (
      <div className={classNames('rfd-ui-tutorial-video', { [className]: className })}>
        <i className={`rfd-ui-tutorial-video-icon icon-aytmfd-videotut`} onClick={this.openPopup} />
        <VideoPopup
          show={popup}
          videos={videos}
          videoId={videoId}
          onClose={this.closePopup}
          videoStartTime={videoStartTime}
        />
      </div>
    )
  }
}
